<template>
    <!-- 人体成分 -->
    <div style="width: auto;">
        <div class="centent-comment-title-div">
            <div class="centent-comment-title">
                历史趋势
            </div>
            <div class="centent-comment-title" style="font-size: 13px;color: #333333;margin-left: 5px;"> Historical Trends</div>
        </div>
        <!-- 表格 -->
        <div class="tabel-box">
            <!-- 第一行 -->
            <div style="display: flex; flex-direction: row; align-items: center;">
                <div class="tabel-tr-title">&nbsp;&nbsp;体重&nbsp;<span class="unit-span">(kg)</span></div>
                <div>
                    <LineChart :data="historyData.lstBodyWeight" :canvasWidth="900" :canvasHeight="80" />
                </div>

            </div>
            <div style="display: flex; flex-direction: row;">
                <div class="line-white"></div>
                <div class="line-green"></div>
            </div>

            <div style="display: flex; flex-direction: row; align-items: center;">
                <div class="tabel-tr-title">&nbsp;&nbsp;肌肉量&nbsp;<span class="unit-span">(kg)</span></div>
                <div>
                    <LineChart :data="historyData.lstBodyMuscleMass" :canvasWidth="900" :canvasHeight="80" />
                </div>

            </div>
            <div style="display: flex; flex-direction: row;">
                <div class="line-white"></div>
                <div class="line-green"></div>
            </div>

            <div style="display: flex; flex-direction: row; align-items: center;">
                <div class="tabel-tr-title">&nbsp;&nbsp;体脂率&nbsp;<span class="unit-span">(%)</span></div>
                <div>
                    <LineChart :data="historyData.lstBodyFatPercentage" :canvasWidth="900" :canvasHeight="80" />
                </div>

            </div>
            <div style="display: flex; flex-direction: row;">
                <div class="line-white"></div>
                <div class="line-green"></div>
            </div>
            <div class="time-box">
                <div v-for="(item, index)  in historyData.lstDate" v-bind="index" :key="index">
                    <div class="time-item">{{ item }}</div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

import LineChart from "@/components/LineChart.vue";

export default {
    data() {
        return {
            chartData: [30, 25, 41, 35, 28, 18], // 这里是你的实际数据
            timeData: ["2024/4/24", "2024/4/24", "2024/4/24", "2024/4/24", "2024/4/24", "2024/4/24",]
        }
    },
    props: {
        historyData: {
            type: Object,
            required: true
        },
        lstBody:{
            type: Object,
            required: true
        }
    },
    mounted() {
        console.log('=======historyData======', this.historyData)
    },
    components: {
        LineChart,
    },
}
</script>


<style scoped>
/* 内容局域  头部文字的公共样式*/
.centent-comment-title-div {
    display: flex;
    flex-direction: row;
}

.centent-comment-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 19px;
    color: #000000;
    line-height: 26px;
    text-align: left;
    font-style: normal;
}
/* 总表格横向列排列 */
.tabel-box {
    display: flex;
    flex-direction: column;
    margin-top: 4px;
    border: 1px solid #F0F9F6;
}

.tabel-tr-title {
    width: 112px;
    height: 54px;
    line-height: 54px;
    text-align: left;
    font-weight: bold;
    font-size: 13px;
    color: #333333;
    border-right: 1px solid #F0F9F6;
}

.tabel-tr-item {
    width: 899px;
    height: 54px;
}

/* 白色下划线 */
.line-white {
    width: 112px;
    height: 1px;
    background: #F0F9F6;
}

/* 绿色下划线 */
.line-green {
    width: 999px;
    background: #F0F9F6;
    height: 1px;
}

.time-box {
    display: flex;
    flex-direction: row;
    width: 899px;
    margin-left: 112px;
    margin-top: 14px;
}

.time-item {
    width: 84px;
    font-size: 9px;
    color: #333333;
}

.mr {
    margin-left: 1px;
}

.unit-span {
    font-weight: 500;
    font-size: 11px;
    color: #333333;
    line-height: 16px;
}
</style>